(() => {
  if (customElements.get('m-cart-complementary')) return;

  // Header cart-count element(s) to update after an add. Adjust if your header uses a different selector.
  const CART_COUNT_SELECTOR = '[data-cart-count]';
  const DRAWER_PART_IDS = ['MinimogCartDrawerHeader', 'MinimogCartDrawerBody', 'MinimogCartDrawerFooter'];

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class CartComplementary extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-recs-track]');
      this.nav = this.querySelector('[data-recs-nav]');
      this.prevBtn = this.querySelector('[data-recs-prev]');
      this.nextBtn = this.querySelector('[data-recs-next]');

      this.addEventListener('click', this.onClick);
      // Stop variant-select events from reaching the theme's cart-items quantity handlers
      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.stop);

      if (this.track) {
        this.track.addEventListener('scroll', this.updateNav, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateNav);
          this.resizeObserver.observe(this.track);
        }
        this.updateNav();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('input', this.stop);

      if (this.track) this.track.removeEventListener('scroll', this.updateNav);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    stop = (event) => event.stopPropagation();

    /* ---------- Carousel ---------- */

    updateNav = () => {
      if (!this.track) return;

      const max = this.track.scrollWidth - this.track.clientWidth;
      const pos = Math.abs(this.track.scrollLeft); // abs() handles RTL negative scrollLeft
      const hasOverflow = max > 2;

      if (this.nav) this.nav.hidden = !hasOverflow;
      if (this.prevBtn) this.prevBtn.disabled = pos <= 2;
      if (this.nextBtn) this.nextBtn.disabled = pos >= max - 2;
    };

    scrollPage(direction) {
      const card = this.track.querySelector('[data-recs-item]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
      const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;

      this.track.scrollBy({ left: direction * rtl * step * perPage, behavior: 'smooth' });
    }

    /* ---------- Variant price ---------- */

    onChange = (event) => {
      event.stopPropagation();

      const select = event.target.closest('[data-recs-variant]');
      if (!select) return;

      const option = select.selectedOptions[0];
      const priceEl = select.closest('[data-recs-item]').querySelector('[data-recs-price]');
      if (!option || !priceEl) return;

      const compare = option.dataset.compare;
      priceEl.innerHTML =
        (compare ? `<s class="m-cart-recs__compare">${compare}</s>` : '') +
        `<span class="m-cart-recs__sale">${option.dataset.price}</span>`;
    };

    /* ---------- Clicks: arrows + add to cart ---------- */

    onClick = async (event) => {
      const arrow = event.target.closest('[data-recs-prev], [data-recs-next]');
      if (arrow) {
        event.preventDefault();
        this.scrollPage(arrow.hasAttribute('data-recs-next') ? 1 : -1);
        return;
      }

      const button = event.target.closest('[data-recs-add]');
      if (!button || button.disabled) return;
      event.preventDefault();

      const item = button.closest('[data-recs-item]');
      const select = item.querySelector('[data-recs-variant]');
      const errorEl = item.querySelector('[data-recs-error]');
      const variantId = Number(select ? select.value : button.dataset.variantId);
      const drawerSectionId = this.dataset.drawerSectionId;

      if (errorEl) errorEl.textContent = '';
      this.setLoading(button, true);

      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: drawerSectionId,
            sections_url: window.location.pathname,
          }),
        });
        const data = await res.json();

        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }

        this.renderDrawer(data.sections && data.sections[drawerSectionId]);
        this.syncCart();
      } catch (error) {
        if (errorEl) errorEl.textContent = error.message;
        this.setLoading(button, false);
      }
    };

    setLoading(button, loading) {
      button.disabled = loading;
      button.classList.toggle('is-loading', loading);
      button.setAttribute('aria-busy', String(loading));
    }

    renderDrawer(html) {
      const doc = html ? new DOMParser().parseFromString(html, 'text/html') : null;

      if (!doc || !DRAWER_PART_IDS.every((id) => doc.getElementById(id))) {
        window.location.reload();
        return;
      }

      DRAWER_PART_IDS.forEach((id) => {
        const current = document.getElementById(id);
        if (current) current.innerHTML = doc.getElementById(id).innerHTML;
      });
    }

    async syncCart() {
      try {
        const cart = await fetch(`${root}cart.js`).then((res) => res.json());

        document.querySelectorAll(CART_COUNT_SELECTOR).forEach((el) => {
          el.textContent = cart.item_count;
        });

        ['cart:updated', 'cart:refresh'].forEach((name) => {
          document.dispatchEvent(
            new CustomEvent(name, { bubbles: true, detail: { cart, source: 'cart-complementary' } })
          );
        });
      } catch (_) {
        /* non-blocking */
      }
    }
  }

  customElements.define('m-cart-complementary', CartComplementary);
})();